import { render, staticRenderFns } from "./ModalInventories.vue?vue&type=template&id=4f832d0c&lang=pug&"
import script from "./ModalInventories.vue?vue&type=script&lang=js&"
export * from "./ModalInventories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports